<template>
    <section
        class="bg-gradient-to-t from-transparent via-accent/10 via-35% to-transparent">
        <div class="container relative">
            <div
                class="pointer-events-none absolute left-0 right-0 top-1/3 h-full w-full opacity-75"></div>
            <AtomTitle> Наша продукция</AtomTitle>
            <OurProductsItems
                class="relative mt-5 max-md:overflow-hidden md:mt-10" />
            <div class="mt-10 text-center md:mt-20">
                <BaseLink
                    to="/catalog"
                    icon-right="arrow-right"
                    size="accent">
                    Смотреть все товары
                </BaseLink>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import AtomTitle from '~/components/atom/atom-title/AtomTitle.vue'
import BaseLink from '~/components/base/base-link/BaseLink.vue'
import OurProductsItems from '~/components/pages/home/our-products/OurProductsItems.vue'
</script>
